<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn mt-3"
                    svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="updateExamQuestions">
                </feather-icon>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.assignAssignments')" position="top">
                <feather-icon icon="SendIcon" class="action-success icon-btn mt-3"
                    svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="openPopupAssigments">
                </feather-icon>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn mt-3"
                    svg-classes="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDelete">
                </feather-icon>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo" title="Giao bài tập" :active.sync="openAssignAssignments"
            v-if="openAssignAssignments" id="asgm">
            <assignmentsInformation :quizId="params.data.id"></assignmentsInformation>
        </vs-popup>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import assignmentsInformation from "../AssignAssignmentsInformation.vue";
export default {
    name: 'CellRendererMultipleChoiceExercises',
    components: {
        vSelect,
        assignmentsInformation
    },
    data() {
        return {
            openAssignAssignments: false,
        }
    },
    methods: {
        openPopupAssigments() {
            this.openAssignAssignments = true;
        },
        updateExamQuestions() {
            this.$router.push(`/user/multiple-choice-question-exercises-info?questionId=${this.params.data.id}`);
        },
        confirmDelete() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Xác nhận xoá',
                text: `Bạn có chắc là muốn xoá đề thi "${this.params.data.schoolQuizName}" không? `,
                accept: this.deleteSchoolQuizName,
                acceptText: 'Xoá',
                cancelText: 'Huỷ',
            })
        },
        deleteSchoolQuizName() {
            this.$vs.loading();
            this.$crm.post(`/school-quiz/delete/${this.params.data.id}`).then((response) => {
                this.$vs.loading.close();
                this.$store.commit('DELETE_TOPICSET', true)
                return this.$vs.notify({
                    text: 'Xóa bộ đề thi thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },

    watch: {
        '$store.state.isClosePopupEmployee'(val) {
            if (val) {
                this.openAssignAssignments = false;
                this.$store.commit('CLOSE_POPUP_EMPLOYEE', false)
            }
        }
    },

}
</script>

<style lang="scss">
#asgm {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
